import {SocialPlatform} from '@/_application/core/types';
import ShareSocialButton from '@/_application/modules/products/details/share-social-button';
import {Product} from '@/_application/modules/products/model/product';
import {useTranslation} from 'next-i18next';
import React from 'react';

interface IProps {
    product: Product;
}

function ProductDetailsSocialMedia({product}: Readonly<IProps>) {
    const {t} = useTranslation();

    if (!product || !product.id) {
        return null;
    }

    return (
        <div className="mx-auto flex max-w-md flex-row items-center justify-between text-sm ">
            <div className="flex flex-row items-center gap-2">
                <p>{t('text-share')}:</p>

                <ShareSocialButton platform={SocialPlatform.Messenger} />
                <ShareSocialButton platform={SocialPlatform.Facebook} />
                <ShareSocialButton platform={SocialPlatform.Twitter} />
            </div>
        </div>
    );
}

export default ProductDetailsSocialMedia;
